import React from 'react';
import { Item } from './styled';
import PropTypes from 'prop-types';

class BottomNavItem extends React.Component {
  static propTypes = {
    action: PropTypes.func.isRequired,
    step: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  };

  changeStep = e => {
    this.props.action(this.props.step, true);
  };

  render() {
    return (
      <Item onClick={this.changeStep} className={this.props.activeClass}>
        {this.props.name}
      </Item>
    );
  }
}

export default BottomNavItem;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/BottomNavItem/BottomNavItem.js